import script from "./MobileProfessionPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileProfessionPage.vue?vue&type=script&lang=ts&setup=true"

import "./MobileProfessionPage.vue?vue&type=style&index=0&id=29dee938&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29dee938"]])

export default __exports__